import { TmHttpClient } from '@treasury/core/http';
import { AccountDto } from '../../types/arp';

export class ArpAccountsRequests {
    static async getArpAccounts(claimType: string) {
        const http = await TmHttpClient.getInstance();
        return http.request<AccountDto[]>(`arp/GetArpAccounts/${claimType}`);
    }
}
